export function TRANSLATE(str: string): string {
  return str;
}
